class Logger {
  baseStyles: string = `
    color: #fff;
    background-color: #ca0031;
    padding: 2px 4px;
    border-radius: 3px;`;

  private debugLogging: boolean = true;

  setDebugLogging(debug: boolean) {
    this.debugLogging = debug;
  }

  log(...args) {
    if (this.debugLogging)
      console.log.apply(this, ["%cMastodon", this.baseStyles, ...args]);
  }

  warn(...args) {
    console.warn.apply(this, ["%cMastodon", this.baseStyles, ...args]);
  }

  error(...args) {
    console.error.apply(this, ["%cMastodon", this.baseStyles, ...args]);
  }

  group(label?: string) {
    console.group("%cMastodon", this.baseStyles, label);
  }

  endGroup() {
    console.groupEnd();
  }

  hero() {
    console.log(
      `%c
██████   ██████                    █████                 █████                    
░░██████ ██████                    ░░███                 ░░███                     
 ░███░█████░███   ██████    █████  ███████    ██████   ███████   ██████  ████████  
 ░███░░███ ░███  ░░░░░███  ███░░  ░░░███░    ███░░███ ███░░███  ███░░███░░███░░███ 
 ░███ ░░░  ░███   ███████ ░░█████   ░███    ░███ ░███░███ ░███ ░███ ░███ ░███ ░███ 
 ░███      ░███  ███░░███  ░░░░███  ░███ ███░███ ░███░███ ░███ ░███ ░███ ░███ ░███ 
 █████     █████░░████████ ██████   ░░█████ ░░██████ ░░████████░░██████  ████ █████
░░░░░     ░░░░░  ░░░░░░░░ ░░░░░░     ░░░░░   ░░░░░░   ░░░░░░░░  ░░░░░░  ░░░░ ░░░░░ 

░█▀▄░█░█░░░█▄█░█▀█░█▀█░█░░░█▀▀░░░█▄█░█▀▀░█▀▄░▀█▀░█▀█
░█▀▄░░█░░░░█░█░█▀█░█▀▀░█░░░█▀▀░░░█░█░█▀▀░█░█░░█░░█▀█
░▀▀░░░▀░░░░▀░▀░▀░▀░▀░░░▀▀▀░▀▀▀░░░▀░▀░▀▀▀░▀▀░░▀▀▀░▀░▀                            
`,
      "color:#ca0031;"
    );
  }
}

export default new Logger();
